import { SetAssignVisitRequestAccepted } from 'Application/Visits/Actions/action'
import BottomSheet from 'Components/BottomSheet'
import { DateTimePicker } from 'Components/DateTimePicker'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

type Props = {
  visitRequestId: number
  scheduleTime: string | null
  isEnabled: boolean
}

const AcceptRequestButton = ({ visitRequestId, scheduleTime, isEnabled }: Props) => {
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  const { t } = useTranslation()

  const [open, setOpen] = useState(false)

  async function onSubmit(scheduleTime: string) {
    try {
      await dispatch(
        SetAssignVisitRequestAccepted({
          data: {
            visitDate: scheduleTime,
            visitRequestId,
          },
          navigate,
          t: t('EDIT_REQUEST'),
        }),
      ).unwrap()
    } catch (error) {}
  }

  return (
    <>
      <button
        className={`btn btn-lg flex gap-2 items-center justify-center w-full ${isEnabled && 'btn-primary'}`}
        disabled={!isEnabled}
        onClick={async () => {
          if (!isEnabled) return
          if (!scheduleTime) {
            setOpen(true)
          } else {
            onSubmit(scheduleTime)
          }
        }}
      >
        {t('ACCEPT_VISIT_REQUEST')}
      </button>

      <BottomSheet title="تعیین زمان بازدید" visible={open} onCancel={() => setOpen(false)}>
        <DateTimePicker
          confirmText="ACCEPT_VISIT_REQUEST"
          minuteStep={15}
          hidePastTimes
          setOpen={setOpen}
          onChange={value => {
            onSubmit(value.utc)
          }}
        />
      </BottomSheet>
    </>
  )
}

export default AcceptRequestButton
